import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import ContactForm from "features/publicPages/components/ContactForm";
import PageTitle from "shared/ui/PageTitle";
import BoxContent from "shared/ui/BoxContent";

const PNRAS = () => {
    return (
        <Box component="main">
            <PageTitle>
                Programul Național pentru Reducerea Abandonului Școlar
            </PageTitle>
            <Typography variant="h3" mb={3}>Runda a II-a</Typography>
                <Typography variant="body1">Brio – prima și singura platformă de testare standardizată din România* –
                    vine în întâmpinarea nevoilor identificate în sistemul educațional românesc, oferind instrumentele
                    de lucru necesare îndeplinirii obiectivelor din cadrul Programului Național pentru Reducerea
                    Abandonului Școlar (PNRAS).
                </Typography>
                <Typography variant="body1">În cadrul proiectului, solicitanții pot beneficia de teste standardizate
                    pentru materiile școlare: matematică, limba română, istorie, fizică, chimie, biologie, geografie,
                    teste de literație și literație digitală, precum și de tot suportul tehnic și cursuri de formare
                    necesare implementării și folosirii platformei în școli, Brio Testare Standardizată fiind cheltuială
                    eligibilă în cadrul Schemei de Granturi PNRAS II.
                </Typography>
              <Typography variant="body1"><b>Runda a II-a a Schemei de Granturi din cadrul PNRAS</b> (aprobat prin H.G. nr.
                    1309/2021), program finanțat prin granturi PNRR (Planul Național de Redresare și Reziliență), se
                    adresează unităților de învățământ preuniversitar de stat care au o rată de abandon școlar ridicată
                    și performanță școlară scăzută la nivel gimnazial.
                </Typography>
                <Typography variant="body2">* Testele standardizate Brio pot fi accesate folosind un dispozitiv
                    electronic (PC, laptop, tabletă sau telefon mobil smart).
                </Typography>
            <Typography variant="h3" mt={3} mb={3}>Intră în legătură cu noi</Typography>
            <Typography variant="body1"><b>Telefon: </b> <a href="tel:+40751237170">0751.237.170</a> (L-V,
                10:00-17:00)</Typography>
            <BoxContent mt={3}>
                <Typography variant="body1">Completează câmpurile de mai jos cu datele școlii tale pentru calcularea
                    costului total.
                </Typography>
                <ContactForm advanced={true} type="PNRAS" />
                <Typography variant="body2" mt={2}>* Daca doriți o ofertă personalizată în funcție de nevoile școlii dumneavoastră, vă rugăm să ne contactați pe adresa de e-mail office@brio.ro.</Typography>
            </BoxContent>
        </Box>
    )
};

export default PNRAS;